import bgImage from '../assets/Background.png';

export default function Mission() {
  // === STYLE OPTIONS ===
  const headingFont = "Montserrat, Arial, sans-serif";
  const headingSize = "2.8rem";
  const headingColor = "#ecececff";

  const paraFont = "Lato, Arial, sans-serif";
  const paraSize = "1.22rem";
  const paraColor = "#ffffffff";

  // Choose: "flex-start", "center", or "flex-end"
  const verticalAlign = "flex-start";
  // Choose: "flex-start", "center", or "flex-end"
  const horizontalAlign = "center";
  // Set textAlign for text (left/center/right)
  const textAlign = "left";



  
  return (
    <div
      style={{
        padding: "36px 12px",
        minHeight: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        justifyContent: verticalAlign,
        alignItems: horizontalAlign
      }}
    >
      <h1
  style={{
    fontFamily: headingFont,
    fontSize: headingSize,
    color: headingColor,
    margin: 0,
    textAlign: textAlign
  }}
>
  Our Mission
</h1>

<div style={{ marginTop: 18, maxWidth: 1200, textAlign: textAlign }}>
  <p
    style={{
      fontFamily: paraFont,
      fontSize: paraSize,
      color: paraColor,
      margin: "0 0 18px 0",
      lineHeight: 1.7
    }}
  >
    Our mission is to revolutionise university admissions in Pakistan through a centralised, student-centric digital platform. Every student’s pathway to higher education, free from geographic and procedural barriers, starts here with us.
  </p>
  <p
    style={{
      fontFamily: paraFont,
      fontSize: paraSize,
      color: paraColor,
      margin: "0 0 18px 0",
      lineHeight: 1.7
    }}
  >
    We are committed to empowering students with clarity, choice, and confidence, while supporting universities in adopting streamlined, eco-friendly, and fully digital admissions processes.
  </p>
  <p
    style={{
      fontFamily: paraFont,
      fontSize: paraSize,
      color: paraColor,
      margin: 0,
      lineHeight: 1.7
    }}
  >
    Serving as the nation’s trusted gateway to higher education, we bring students and institutions together in a spirit of equity, collaboration, and progress, ensuring that opportunity knows no boundaries.
  </p>
</div>

    </div>
  );
}
